export { default } from './ComVeureEscoltar';
